import { generateColors } from '@mantine/colors-generator'
import { createTheme, Portal } from '@mantine/core'

const brandColors = generateColors('ffc130')

export const theme = createTheme({
  fontFamily: `Nunito Sans, sans-serif`,
  breakpoints: {
    xs: `30em`,
    sm: `48em`,
    md: `64em`,
    lg: `74em`,
    xl: `90em`,
  },
  headings: {
    fontFamily: `Nunito Sans, sans-serif`,
  },
  colors: {
    brand: brandColors,
  },
  primaryColor: `brand`,
  primaryShade: 7,
  autoContrast: true,

  components: {
    Button: {
      styles: () => ({
        root: {
          borderRadius: 1000,
          // fontWeight: 500,
          // color: BLACK_COLOR,
        },
      }),
    },
    Table: {
      styles: () => ({
        thead: {
          backgroundColor: 'var(--mantine-primary-color-light)',
        },
      }),
    },
    Portal: Portal.extend({
      defaultProps: {
        reuseTargetNode: false,
      },
    }),
  },
  autoContrast: true,
})
